import React from 'react';
import cn from 'classnames';

import { IMG_TINT_ATTR, UNIFORM_PROPS } from 'common/constants';
import { BBCommonProps } from 'types/story';
import withCardTransitionContext from 'client/components/common/BuildingBlocks/BuildingBlockEnhancer';
import { getLinkProps } from 'client/components/common/BuildingBlocks/utils/common';
import { EventProviderContextT, withEventProvider } from 'client/components/pages/Story/EventProvider/Context';

import css from './Img.scss';

type Props = BBCommonProps & EventProviderContextT;

class Img extends React.Component<Props> {
	get eventListeners() {
		if (this.props.isEditableMode) {
			return {};
		}

		return {
			onClick: () => {
				const externalLink = this.props.uiConfig.componentProps[UNIFORM_PROPS.btnLink];
				const internalLink = externalLink ? '' : this.props.uiConfig.componentProps[UNIFORM_PROPS.btnNavLink];
				if (internalLink) this.props.eventProvider.events.flow(internalLink, true);
			},
		};
	}

	renderEditable() {
		const props = { ...this.props.editableModeProps?.nodeProps };
		return this.renderDefault(props);
	}

	renderDefault(props: any = {}) {
		const { stateAttrs, eventListeners } = this.props;
		const { nodeProps } = this.props.uiConfig;
		const className = cn(css.img, nodeProps.className, props.className);
		const { Component, ...componentProps } = getComponent(this.props);

		return (
			<Component
				{...componentProps}
				{...nodeProps}
				{...stateAttrs}
				{...eventListeners}
				{...this.eventListeners}
				{...props}
				className={className}
				ref={this.props.containerRef}
			>
				<span {...{ [IMG_TINT_ATTR]: '' }} />
			</Component>
		);
	}

	render() {
		return this.props.isEditableMode ? this.renderEditable() : this.renderDefault();
	}
}

function getComponent(props: Props) {
	const externalLink = props.uiConfig.componentProps[UNIFORM_PROPS.btnLink];

	if (externalLink && !props.isEditableMode) {
		return getLinkProps(props, { link: externalLink });
	}

	return {
		Component: 'div',
	};
}

export default withEventProvider(withCardTransitionContext(Img));
